import React from 'react';

const SpotifyIcon = () => {
    return (
        <svg
            version="1.1"
            id="svg2"
            width="226.73334"
            height="226.73334"
            viewBox="0 0 226.73334 226.73334"
            xmlns="http://www.w3.org/2000/svg"
            style={{width:20, height:20, marginLeft:6}}
        >
        <defs
            id="defs6" />
        <g
            id="g8"
            transform="matrix(1.3333333,0,0,-1.3333333,0,226.73333)">
            <g
            id="g10"
            transform="scale(0.1)">
            <path
                d="m 1345.62,945.281 c -269.94,160.309 -715.202,175.049 -972.893,96.839 -41.383,-12.56 -85.145,10.81 -97.68,52.18 -12.543,41.41 10.793,85.14 52.207,97.72 295.812,89.79 787.556,72.45 1098.316,-112.02 37.22,-22.1 49.43,-70.17 27.37,-107.328 -22.08,-37.219 -70.19,-49.488 -107.32,-27.391 z m -8.84,-237.441 c -18.94,-30.731 -59.12,-40.371 -89.81,-21.5 -225.05,138.336 -568.216,178.41 -834.466,97.59 -34.527,-10.434 -70.996,9.035 -81.484,43.496 -10.403,34.527 9.074,70.929 43.539,81.429 304.152,92.295 682.261,47.59 940.741,-111.253 30.69,-18.903 40.35,-59.102 21.48,-89.762 z M 1234.31,479.809 c -15.05,-24.68 -47.18,-32.411 -71.77,-17.368 -196.653,120.188 -444.173,147.329 -735.673,80.75 -28.09,-6.441 -56.086,11.161 -62.492,39.25 -6.434,28.079 11.102,56.079 39.254,62.489 318.996,72.925 592.633,41.539 813.361,-93.34 24.61,-15.031 32.36,-47.18 17.32,-71.781 z M 850.254,1687.68 c -462.496,0 -837.4337,-374.93 -837.4337,-837.418 0,-462.543 374.9377,-837.4417 837.4337,-837.4417 462.506,0 837.426,374.8987 837.426,837.4417 0,462.488 -374.92,837.418 -837.426,837.418"
                style={{fill:'#000',fillOpacity:1,fillRule:'nonzero',stroke:'none'}}
                id="path12" />
            </g>
        </g>
        </svg>
    );
}

export {SpotifyIcon};
